import { render, staticRenderFns } from "./ActiveProject.vue?vue&type=template&id=3698db55&"
import script from "./ActiveProject.vue?vue&type=script&lang=js&"
export * from "./ActiveProject.vue?vue&type=script&lang=js&"
import style0 from "./ActiveProject.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports